import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadCustom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_6003_13615",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 14,
		height: 14,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14 0H0V14H14V0Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_6003_13615)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0.467156 8.71094C0.343259 8.71094 0.224436 8.76016 0.136827 8.84778C0.0492181 8.93539 0 9.05423 0 9.17814L0 12.0815C0.000881675 12.5902 0.203289 13.0778 0.562901 13.4376C0.922513 13.7973 1.41002 13.9999 1.91868 14.001H12.0793C12.5882 14.0003 13.0761 13.7978 13.436 13.438C13.7959 13.0782 13.9984 12.5904 13.9993 12.0815V9.17814C13.9993 9.11678 13.9872 9.05603 13.9638 8.99935C13.9403 8.94266 13.9059 8.89116 13.8625 8.84778C13.8191 8.80439 13.7676 8.76998 13.7109 8.7465C13.6543 8.72302 13.5935 8.71094 13.5322 8.71094C13.4708 8.71094 13.4101 8.72302 13.3534 8.7465C13.2967 8.76998 13.2452 8.80439 13.2018 8.84778C13.1585 8.89116 13.1241 8.94266 13.1006 8.99935C13.0771 9.05603 13.065 9.11678 13.065 9.17814V12.0815C13.0645 12.3427 12.9604 12.593 12.7757 12.7777C12.5909 12.9623 12.3405 13.0662 12.0793 13.0666H1.91868C1.65776 13.0657 1.4078 12.9616 1.22336 12.777C1.03893 12.5925 0.935016 12.3424 0.934312 12.0815V9.17814C0.934312 9.05423 0.885094 8.93539 0.797485 8.84778C0.709877 8.76016 0.591054 8.71094 0.467156 8.71094Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7.46716 9.17645V1.59178L10.3001 4.42568C10.3887 4.51046 10.5065 4.55777 10.6291 4.55777C10.7517 4.55777 10.8696 4.51046 10.9581 4.42568C11.0456 4.33809 11.0947 4.21939 11.0947 4.09564C11.0947 3.97189 11.0456 3.85319 10.9581 3.7656L7.33502 0.142122C7.28988 0.0956277 7.23556 0.0590336 7.17552 0.0346657C7.08148 -0.00752043 6.9747 -0.0113517 6.87788 0.0239868C6.85815 0.0305399 6.8378 0.0350137 6.81715 0.0373354C6.7618 0.0590903 6.71142 0.0917779 6.66899 0.133445L3.04052 3.7656C2.96348 3.85529 2.92332 3.97086 2.92812 4.089C2.93292 4.20715 2.98234 4.31908 3.06641 4.40222C3.15047 4.48536 3.26293 4.53353 3.38111 4.53702C3.49929 4.54051 3.61439 4.49905 3.70322 4.42101L6.53351 1.59044V9.17712C6.53351 9.30102 6.58273 9.41986 6.67034 9.50748C6.75795 9.59509 6.87677 9.64432 7.00067 9.64432C7.12457 9.64432 7.24339 9.59509 7.331 9.50748C7.41861 9.41986 7.46783 9.30102 7.46783 9.17712",
			fill: "currentColor"
		})]
	})]
});
export default SvgUploadCustom;
